var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.getActiveMenu === 1)?_c('div',[_c('Home')],1):_c('div',[_c('Coopmode')],1)}
var staticRenderFns = []

export { render, staticRenderFns }